export const CANVASKIT_VERSION = "0.40.0";
